import { useState, useEffect } from 'react';
import { storageManager } from '../services/StorageManager';

export const useUnreadCount = () => {
    const [unreadCount, setUnreadCount] = useState<number>(0);

    const fetchUnreadCount = async () => {
        try {
            const count = await storageManager.getUnreadCount();
            setUnreadCount(count);
        } catch (err) {
            console.error('Failed to fetch unread count:', err);
        }
    };

    useEffect(() => {
        // Initial fetch
        fetchUnreadCount();

        // Listen for updates
        const channel = new BroadcastChannel('feed_updates');

        const handleMessage = (event: MessageEvent) => {
            // Any update to the feed should trigger a re-fetch of the unread count
            fetchUnreadCount();
        };

        channel.addEventListener('message', handleMessage);

        return () => {
            channel.removeEventListener('message', handleMessage);
            channel.close();
        };
    }, []);

    return unreadCount;
};
